<template>
    <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        :inline="true"
        label-width="150px"
        class="demo-ruleForm"
        size="small "
    >
        <el-form-item label="直播课程名称" prop="video_title">
            <el-input v-model="ruleForm.video_title"></el-input>
        </el-form-item>
        <el-form-item label="课程资源库" prop="course_ware_id">
            <el-select
                v-model="ruleForm.course_ware_id"
                placeholder="请选择课程资源库"
            >
                <el-option
                    :label="item.ware_name"
                    :value="item.id"
                    v-for="item in waresList"
                    :key="item.id"
                >
                </el-option>
            </el-select>
        </el-form-item>
        <el-row>
            <el-col :span="12">
                <el-form-item label="是否公开报名" prop="is_overt">
                    <el-radio-group v-model="ruleForm.is_overt">
                        <el-radio label="1">是</el-radio>
                        <el-radio label="0">否</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="承诺书" prop="video_undertaking_id">
                    <el-select
                        v-model="ruleForm.video_undertaking_id"
                        placeholder="请选择承诺书"
                    >
                        <el-option
                            :label="item.video_undertaking_title"
                            :value="item.id"
                            v-for="item in underTakingsList"
                            :key="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-col>
        </el-row>

        <el-form-item label="报名方式" prop="apply_type">
            <el-select
                v-model="ruleForm.apply_type"
                placeholder="请选择报名方式"
            >
                <el-option label="先审核后缴费" value="1"></el-option>
                <el-option label="先缴费后审核" value="2"></el-option>
                <el-option label="仅审核无缴费" value="3"></el-option>
                <el-option label="无审核仅缴费" value="4"></el-option>
                <el-option label="无审核无缴费" value="5"></el-option>
            </el-select>
            <span v-if="ruleForm.apply_type === '1'"
                >说明：本方式<span style="color: red">需要审核且报名收费</span
                >，需要学员先提交报名信息进行审核，通过后才能进行缴费。</span
            >
            <span v-if="ruleForm.apply_type === '2'"
                >说明：本方式<span style="color: red">需要审核且报名收费</span
                >，学员需要先提交报名信息且缴费后，再进行报名资格审核。</span
            >
            <span v-if="ruleForm.apply_type === '3'"
                >说明：本方式<span style="color: red">报名免费</span
                >，学员提交报名信息进行审核，审核通过后无需缴费。</span
            >
            <span v-if="ruleForm.apply_type === '4'"
                >说明：本方式<span style="color: red">报名收费</span
                >，学员只需进行报名缴费，不对学员信息进行审核。</span
            >
            <span v-if="ruleForm.apply_type === '5'"
                >说明：本方式
                <span style="color: red">报名公开免费</span>
                ，学员报名后即可学习，无需审核无需缴费。</span
            >
        </el-form-item>

        <el-form-item label="报名信息：" prop="signup_info_ids">
            <el-checkbox-group v-model="ruleForm.signup_info_ids">
                <el-checkbox
                    v-for="item in signupInfoList"
                    :label="item.id"
                    :key="item.id"
                >
                    {{ item.title }}
                </el-checkbox>
            </el-checkbox-group>
        </el-form-item>

        <el-row>
            <el-col :span="12">
                <el-form-item label="机构名称：" prop="mhm_id">
                    <el-select
                        v-model="ruleForm.mhm_id"
                        placeholder="请选择机构名称"
                        @change="schoolChange"
                    >
                        <el-option
                            :label="item.title"
                            :value="item.id"
                            v-for="item in schoolList"
                            :key="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="课程讲师：" prop="teacher_id">
                    <el-select
                        v-model="ruleForm.teacher_id"
                        placeholder="请选择讲师名称"
                    >
                        <el-option
                            v-for="item in teacherList"
                            :label="item.name"
                            :value="item.id"
                            :key="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="8">
                <el-form-item label="原价(市场价格)：" prop="v_price">
                    <el-input
                        v-model="ruleForm.v_price"
                        min="0.01"
                    ></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="8">
                <el-form-item label="销售价格：" prop="t_price">
                    <el-input
                        v-model="ruleForm.t_price"
                        min="0.01"
                    ></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="8">
                <el-form-item
                    label="是否主动提供发票"
                    prop="is_active_invoicing"
                >
                    <el-radio-group v-model="ruleForm.is_active_invoicing">
                        <el-radio label="1">主动开票</el-radio>
                        <el-radio label="0">不主动开票</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="12">
                <el-form-item label="封面上传" prop="cover">
                    <el-upload
                        class="upload-demo"
                        action="https://gz.hnjk.net/index.php?app=course&mod=AdminLineClass&act=uploadCover"
                        :on-remove="handleRemove"
                        :on-success="successFn"
                        :file-list="picList"
                        name="files"
                        list-type="picture"
                    >
                        <el-button size="small" type="primary"
                            >点击上传</el-button
                        >
                        <div slot="tip" class="el-upload__tip">
                            只能上传jpg/png文件，且不超过500kb
                        </div>
                    </el-upload>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="课程订单有效期" prop="term">
                    <el-input v-model="ruleForm.term"></el-input>
                    单位：天，0为永久有效
                </el-form-item>
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="12">
                <el-form-item label="是否精选" prop="is_best">
                    <el-switch
                        v-model="ruleForm.is_best"
                        active-value="1"
                        inactive-value="0"
                    ></el-switch>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="精选排序" prop="best_sort">
                    <el-input v-model="ruleForm.best_sort"></el-input>
                    值越大越靠前
                </el-form-item>
            </el-col>
        </el-row>

        <el-form-item label="附件上传" prop="videofile_ids">
            <el-upload
                class="upload-demo"
                action="https://gz.hnjk.net/index.php?app=course&mod=AdminLineClass&act=uploadCover"
                :file-list="fileList"
                name="files"
                :on-success="successFileFn"
            >
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">
                    只能上传jpg/png文件，且不超过500kb
                </div>
            </el-upload>
        </el-form-item>
        <el-form-item label="显示位置" prop="show_place">
            <el-radio-group v-model="ruleForm.show_place">
                <el-radio label="0">平台与机构</el-radio>
                <el-radio label="1">平台</el-radio>
                <el-radio label="2">机构</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="直播简介" prop="video_intro">
            <quill-editor v-model="ruleForm.video_intro"> </quill-editor>
        </el-form-item>
        <el-form-item style="width: 100%; text-align: center">
            <el-button type="primary" @click="submitForm('ruleForm')"
                >保存</el-button
            >
            <el-button @click="$emit('backFn')">返回</el-button>
        </el-form-item>
    </el-form>
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";

import {
    getLiveTableListById,
    getTeacherList,
    getSchoolList,
    getwaresList,
    getUnderTakingsList,
    getSignUpInfosList,
    addLineCLass,
} from "@/api/LiveLesson/index.js";
export default {
    data() {
        return {
            // 表单数据
            ruleForm: {
                video_title: "",
                course_ware_id: "",
                is_overt: "",
                video_undertaking_id: "",
                apply_type: "",
                signup_info_ids: [],
                mhm_id: "",
                teacher_id: "",
                v_price: "",
                t_price: "",
                is_active_invoicing: "",
                cover: "",
                cover_img: "",
                term: "",
                is_best: "",
                best_sort: "",
                file: "",
                file_name:'',
                videofile_ids: "",
                show_place: "",
                video_intro: "",
            },
            // 表单规则
            rules: {
                video_title: [
                    {
                        required: true,
                        message: "请填写直播课程名称",
                        trigger: "blur",
                    },
                ],
                course_ware_id: [
                    {
                        required: true,
                        message: "请选择课程资源库",
                        trigger: "change",
                    },
                ],
                is_overt: [
                    {
                        required: true,
                        message: "请选择是否公开报名",
                        trigger: "change",
                    },
                ],
                video_undertaking_id: [
                    {
                        required: true,
                        message: "请选择承诺书",
                        trigger: "change",
                    },
                ],
                apply_type: [
                    {
                        required: true,
                        message: "请选择报名方式",
                        trigger: "change",
                    },
                ],
                signup_info_ids: [
                    {
                        required: true,
                        message: "请选择报名信息",
                        trigger: "change",
                    },
                ],
                mhm_id: [
                    {
                        required: true,
                        message: "请选择合作院校",
                        trigger: "change",
                    },
                ],
                teacher_id: [
                    {
                        required: true,
                        message: "请选择老师",
                        trigger: "change",
                    },
                ],
                v_price: [
                    {
                        required: true,
                        message: "请填写原价(市场价格)",
                        trigger: "blur",
                    },
                ],
                t_price: [
                    {
                        required: true,
                        message: "请填写销售价",
                        trigger: "blur",
                    },
                ],
                is_active_invoicing: [
                    {
                        required: true,
                        message: "请选择是否主动提供发票",
                        trigger: "change",
                    },
                ],
                cover_img: [
                    {
                        required: true,
                        message: "请选择封面",
                        trigger: "change",
                    },
                ],
                term: [
                    {
                        required: true,
                        message: "请填写课程订单有效期",
                        trigger: "blur",
                    },
                ],

                show_place: [
                    {
                        required: true,
                        message: "请选择显示位置",
                        trigger: "change",
                    },
                ],
                video_intro: [
                    {
                        required: true,
                        message: "请填写活动形式",
                        trigger: "blur",
                    },
                ],
            },
            // 成功上传图片
            picList: [],
            // 成功上传文件
            fileList: [],
            // 老师
            teacherList: [],
            // 学校
            schoolList: [],
            // 资源库
            waresList: [],
            // 承诺书
            underTakingsList: [],
            // 报名信息
            signupInfoList: [],
        };
    },
    methods: {
        // 编辑保存
        submitForm(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    if (this.ruleForm.course_ware_id==='') {
                        return this.$message('请选择课程资源库')
                    }
                    await addLineCLass(this.ruleForm);
                    this.$message("保存成功");
                    // 编辑保存发送请求
                    this.$emit("addLineClass");
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },

        // 封面上传成功
        successFn(res, file, fileList) {
            this.$message("上传成功");
            this.ruleForm.cover = res.data;
        },
        // 文件上传
        successFileFn(res, file, fileList) {
            this.$message("上传成功");
            this.ruleForm.videofile_ids = res.data;
        },
        picUrl(u) {
            // let url = window.location.protocol + "//" + window.location.host;
            // if (window.location.host == "localhost:5001") {
            //     url = "http://gz.hnjk.net/" + u;
            // }
            // if (window.location.host == "localhost:5001") {
            //     url = "http://gz.hnjk.net/" + "/zk" + u;
            // }
            let url = "http://gz.hnjk.net/" + u;
            return url;
        },
        async init() {
            if (this.courseId) {
                let res = await getLiveTableListById({ id: this.courseId });
                res = JSON.parse(JSON.stringify(res));
                this.ruleForm = {
                    ...res.data.data,
                    signup_info_ids: res.data.data.signup_info_ids.split(","),
                };
                let teacher = await getTeacherList({
                    mhmId: this.ruleForm.mhm_id,
                });
                teacher = JSON.parse(JSON.stringify(teacher));
                this.teacherList = teacher.data.data || [];
                this.fileList.push({
                    name: this.ruleForm.file_name,
                    url: this.picUrl(this.ruleForm.file),
                });
                this.picList.push({
                    url: this.picUrl(this.ruleForm.cover_img),
                });
            }
            let school = await getSchoolList();
            let wares = await getwaresList();
            let underTakings = await getUnderTakingsList();
            let signupInfo = await getSignUpInfosList();

            school = JSON.parse(JSON.stringify(school));
            wares = JSON.parse(JSON.stringify(wares));
            underTakings = JSON.parse(JSON.stringify(underTakings));
            signupInfo = JSON.parse(JSON.stringify(signupInfo));

            this.schoolList = school.data.data || [];
            this.waresList = [{id:'',ware_name:'请选择课程资源库'},...wares.data.data] || [];
            this.underTakingsList = underTakings.data.data || [];
            this.signupInfoList = signupInfo.data.data || [];
        },
        async schoolChange() {
            let teacher = await getTeacherList({
                mhmId: this.ruleForm.mhm_id,
            });
            teacher = JSON.parse(JSON.stringify(teacher));
            this.teacherList = teacher.data.data || [];
        },
    },
    created() {
        this.init();
    },
    components: {
        quillEditor,
    },
    props: ["courseId"],
};
</script>

<style lang="scss" scoped>
.el-form-item {
    padding-bottom: 20px;
    border-bottom: 1px solid #eee;
}
</style>